import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    dashboard: 'Dashboard',
    packages: 'Packages',
    customers: 'Customers',
    invoices: 'Invoices',
    payments: 'Payments',
    notifications: 'Notifications',
    settings: 'Settings',
    logout: 'Logout',
    welcomeBack: 'Welcome Back',
    signIn: 'Sign In',
    signInDesc: 'Access your Track My Package dashboard',
    email: 'Email',
    password: 'Password',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    dontHaveAccount: "Don't have an account?",
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    fullName: 'Full Name',
    enterName: 'Enter your full name',
    createAccountBtn: 'Create Account',
    totalPackages: 'Total Packages',
    totalCustomers: 'Total Customers',
    totalRevenue: 'Total Revenue',
    pendingRevenue: 'Pending',
    recentPackages: 'Recent Packages',
    viewAll: 'View All',
    packageStatus: 'Package Status',
    intakeMiami: 'Intake Miami',
    inTransit: 'In Transit to San José',
    arrivedSanJose: 'Arrived San José',
    readyForPickup: 'Ready for Pickup',
    delivered: 'Delivered',
    pending: 'Pending',
    paid: 'Paid',
    overdue: 'Overdue',
    cancelled: 'Cancelled',
    newPackage: 'New Package',
    trackingNumber: 'Tracking #',
    customer: 'Customer',
    description: 'Description',
    weight: 'Weight',
    weightLbs: 'Weight (lbs)',
    weightKg: 'Weight (kg)',
    status: 'Status',
    cost: 'Cost',
    actions: 'Actions',
    scanPackage: 'Scan Package',
    searchPackages: 'Search packages...',
    noPackages: 'No packages found',
    createFirstPackage: 'Create your first package to get started',
    selectCustomer: 'Select customer',
    dimensions: 'Dimensions (optional)',
    declaredValue: 'Declared Value (optional)',
    notes: 'Notes (optional)',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    newCustomer: 'New Customer',
    searchCustomers: 'Search customers...',
    noCustomers: 'No customers found',
    addFirstCustomer: 'Add your first customer to get started',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    totalPackagesLabel: 'Total Packages',
    balance: 'Balance',
    newInvoice: 'New Invoice',
    invoiceNumber: 'Invoice #',
    amount: 'Amount',
    dueDate: 'Due Date',
    selectPackages: 'Select Packages',
    noInvoices: 'No invoices found',
    createFirstInvoice: 'Create your first invoice',
    subtotal: 'Subtotal',
    total: 'Total',
    exchangeRate: 'Exchange Rate',
    payNow: 'Pay Now',
    sendPaymentLink: 'Send Payment Link',
    paymentTransactions: 'Payment Transactions',
    completed: 'Completed',
    acceptedMethods: 'Accepted Payment Methods',
    creditDebitCards: 'Credit/Debit Cards',
    bankTransfer: 'Bank Transfer',
    markAllRead: 'Mark All Read',
    noNotifications: 'No notifications',
    notificationTypes: 'Notification Types',
    scanBarcode: 'Scan Barcode',
    pointCamera: 'Point your camera at the barcode',
    manualEntry: 'Manual Entry',
    enterTracking: 'Enter tracking number',
    search: 'Search',
    closeScanner: 'Close Scanner',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    save: 'Save',
    close: 'Close',
    installApp: 'Install Track My Package',
    installDesc: 'Add to your home screen for quick access',
    install: 'Install',
    later: 'Later',
    reports: 'Reports',
    companyBranding: 'Company Branding',
    customizeBranding: 'Customize logo, color, and pricing',
    companyLogo: 'Company Logo',
    uploadLogo: 'Upload Logo',
    primaryColor: 'Primary Color',
    companyName: 'Company Name',
    pricePerPound: 'Price per Pound ($USD)',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    deliveryProof: 'Delivery Proof',
    uploadPhoto: 'Upload Photo',
    noDeliveryProof: 'No delivery proof yet',
    uploadEvidence: 'Upload a photo as evidence',
    uploaded: 'Uploaded',
    distribution: 'Distribution',
    batchUpdate: 'Batch Update',
    importCsv: 'Import CSV',
  },
  es: {
    dashboard: 'Panel',
    packages: 'Paquetes',
    customers: 'Clientes',
    invoices: 'Facturas',
    payments: 'Pagos',
    notifications: 'Notificaciones',
    settings: 'Configuración',
    logout: 'Cerrar Sesión',
    welcomeBack: 'Bienvenido',
    signIn: 'Iniciar Sesión',
    signInDesc: 'Accede a tu panel de Track My Package',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    enterEmail: 'Ingresa tu correo',
    enterPassword: 'Ingresa tu contraseña',
    dontHaveAccount: '¿No tienes cuenta?',
    createAccount: 'Crear Cuenta',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    fullName: 'Nombre Completo',
    enterName: 'Ingresa tu nombre completo',
    createAccountBtn: 'Crear Cuenta',
    totalPackages: 'Total Paquetes',
    totalCustomers: 'Total Clientes',
    totalRevenue: 'Ingresos Totales',
    pendingRevenue: 'Pendiente',
    recentPackages: 'Paquetes Recientes',
    viewAll: 'Ver Todo',
    packageStatus: 'Estado de Paquetes',
    intakeMiami: 'Recibido Miami',
    inTransit: 'En Tránsito a San José',
    arrivedSanJose: 'Llegó a San José',
    readyForPickup: 'Listo para Recoger',
    delivered: 'Entregado',
    pending: 'Pendiente',
    paid: 'Pagado',
    overdue: 'Vencido',
    cancelled: 'Cancelado',
    newPackage: 'Nuevo Paquete',
    trackingNumber: 'Tracking #',
    customer: 'Cliente',
    description: 'Descripción',
    weight: 'Peso',
    weightLbs: 'Peso (libras)',
    weightKg: 'Peso (kg)',
    status: 'Estado',
    cost: 'Costo',
    actions: 'Acciones',
    scanPackage: 'Escanear Paquete',
    searchPackages: 'Buscar paquetes...',
    noPackages: 'No hay paquetes',
    createFirstPackage: 'Crea tu primer paquete para comenzar',
    selectCustomer: 'Seleccionar cliente',
    dimensions: 'Dimensiones (opcional)',
    declaredValue: 'Valor Declarado (opcional)',
    notes: 'Notas (opcional)',
    cancel: 'Cancelar',
    create: 'Crear',
    update: 'Actualizar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    newCustomer: 'Nuevo Cliente',
    searchCustomers: 'Buscar clientes...',
    noCustomers: 'No hay clientes',
    addFirstCustomer: 'Agrega tu primer cliente para comenzar',
    phone: 'Teléfono',
    address: 'Dirección',
    city: 'Ciudad',
    totalPackagesLabel: 'Total Paquetes',
    balance: 'Saldo',
    newInvoice: 'Nueva Factura',
    invoiceNumber: 'Factura #',
    amount: 'Monto',
    dueDate: 'Fecha de Vencimiento',
    selectPackages: 'Seleccionar Paquetes',
    noInvoices: 'No hay facturas',
    createFirstInvoice: 'Crea tu primera factura',
    subtotal: 'Subtotal',
    total: 'Total',
    exchangeRate: 'Tipo de Cambio',
    payNow: 'Pagar Ahora',
    sendPaymentLink: 'Enviar Link de Pago',
    paymentTransactions: 'Transacciones de Pago',
    completed: 'Completado',
    acceptedMethods: 'Métodos de Pago Aceptados',
    creditDebitCards: 'Tarjetas de Crédito/Débito',
    bankTransfer: 'Transferencia Bancaria',
    markAllRead: 'Marcar Todo Leído',
    noNotifications: 'Sin notificaciones',
    notificationTypes: 'Tipos de Notificaciones',
    scanBarcode: 'Escanear Código',
    pointCamera: 'Apunta tu cámara al código de barras',
    manualEntry: 'Entrada Manual',
    enterTracking: 'Ingresa el número de tracking',
    search: 'Buscar',
    closeScanner: 'Cerrar Escáner',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    confirm: 'Confirmar',
    save: 'Guardar',
    close: 'Cerrar',
    installApp: 'Instalar Track My Package',
    installDesc: 'Agregar a tu pantalla de inicio para acceso rápido',
    install: 'Instalar',
    later: 'Después',
    reports: 'Reportes',
    companyBranding: 'Marca de la Empresa',
    customizeBranding: 'Personaliza logo, color y precios',
    companyLogo: 'Logo de la empresa',
    uploadLogo: 'Subir Logo',
    primaryColor: 'Color Primario',
    companyName: 'Nombre de Empresa',
    pricePerPound: 'Precio por Libra ($USD)',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    deliveryProof: 'Prueba de Entrega',
    uploadPhoto: 'Subir Foto',
    noDeliveryProof: 'Sin prueba de entrega',
    uploadEvidence: 'Sube una foto como evidencia',
    uploaded: 'Subido',
    distribution: 'Distribución',
    batchUpdate: 'Actualización Masiva',
    importCsv: 'Importar CSV',
  },
  fr: {
    dashboard: 'Tableau de Bord',
    packages: 'Colis',
    customers: 'Clients',
    invoices: 'Factures',
    payments: 'Paiements',
    notifications: 'Notifications',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    welcomeBack: 'Bienvenue',
    signIn: 'Se Connecter',
    signInDesc: 'Accédez à votre tableau de bord Track My Package',
    email: 'E-mail',
    password: 'Mot de passe',
    enterEmail: 'Entrez votre e-mail',
    enterPassword: 'Entrez votre mot de passe',
    dontHaveAccount: "Pas encore de compte ?",
    createAccount: 'Créer un Compte',
    alreadyHaveAccount: 'Déjà un compte ?',
    fullName: 'Nom Complet',
    enterName: 'Entrez votre nom complet',
    createAccountBtn: 'Créer un Compte',
    totalPackages: 'Total Colis',
    totalCustomers: 'Total Clients',
    totalRevenue: 'Revenu Total',
    pendingRevenue: 'En Attente',
    recentPackages: 'Colis Récents',
    viewAll: 'Voir Tout',
    packageStatus: 'État des Colis',
    intakeMiami: 'Réception Miami',
    inTransit: 'En Transit vers San José',
    arrivedSanJose: 'Arrivé à San José',
    readyForPickup: 'Prêt pour Retrait',
    delivered: 'Livré',
    pending: 'En Attente',
    paid: 'Payé',
    overdue: 'En Retard',
    cancelled: 'Annulé',
    newPackage: 'Nouveau Colis',
    trackingNumber: 'N° Suivi',
    customer: 'Client',
    description: 'Description',
    weight: 'Poids',
    weightLbs: 'Poids (livres)',
    weightKg: 'Poids (kg)',
    status: 'Statut',
    cost: 'Coût',
    actions: 'Actions',
    scanPackage: 'Scanner un Colis',
    searchPackages: 'Rechercher des colis...',
    noPackages: 'Aucun colis trouvé',
    createFirstPackage: 'Créez votre premier colis pour commencer',
    selectCustomer: 'Sélectionner un client',
    dimensions: 'Dimensions (optionnel)',
    declaredValue: 'Valeur Déclarée (optionnel)',
    notes: 'Notes (optionnel)',
    cancel: 'Annuler',
    create: 'Créer',
    update: 'Mettre à jour',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    newCustomer: 'Nouveau Client',
    searchCustomers: 'Rechercher des clients...',
    noCustomers: 'Aucun client trouvé',
    addFirstCustomer: 'Ajoutez votre premier client pour commencer',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    totalPackagesLabel: 'Total Colis',
    balance: 'Solde',
    newInvoice: 'Nouvelle Facture',
    invoiceNumber: 'Facture #',
    amount: 'Montant',
    dueDate: "Date d'Échéance",
    selectPackages: 'Sélectionner des Colis',
    noInvoices: 'Aucune facture trouvée',
    createFirstInvoice: 'Créez votre première facture',
    subtotal: 'Sous-total',
    total: 'Total',
    exchangeRate: 'Taux de Change',
    payNow: 'Payer Maintenant',
    sendPaymentLink: 'Envoyer le Lien de Paiement',
    paymentTransactions: 'Transactions de Paiement',
    completed: 'Terminé',
    acceptedMethods: 'Méthodes de Paiement Acceptées',
    creditDebitCards: 'Cartes de Crédit/Débit',
    bankTransfer: 'Virement Bancaire',
    markAllRead: 'Tout Marquer comme Lu',
    noNotifications: 'Aucune notification',
    notificationTypes: 'Types de Notifications',
    scanBarcode: 'Scanner le Code-barres',
    pointCamera: 'Pointez votre caméra vers le code-barres',
    manualEntry: 'Saisie Manuelle',
    enterTracking: 'Entrez le numéro de suivi',
    search: 'Rechercher',
    closeScanner: 'Fermer le Scanner',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    close: 'Fermer',
    installApp: 'Installer Track My Package',
    installDesc: "Ajoutez à votre écran d'accueil pour un accès rapide",
    install: 'Installer',
    later: 'Plus tard',
    reports: 'Rapports',
    companyBranding: "Image de Marque",
    customizeBranding: 'Personnalisez le logo, les couleurs et les tarifs',
    companyLogo: "Logo de l'entreprise",
    uploadLogo: 'Télécharger le Logo',
    primaryColor: 'Couleur Principale',
    companyName: "Nom de l'Entreprise",
    pricePerPound: 'Prix par Livre ($USD)',
    saveChanges: 'Enregistrer les Modifications',
    saving: 'Enregistrement...',
    deliveryProof: 'Preuve de Livraison',
    uploadPhoto: 'Télécharger une Photo',
    noDeliveryProof: 'Pas encore de preuve de livraison',
    uploadEvidence: 'Téléchargez une photo comme preuve',
    uploaded: 'Téléchargé',
    distribution: 'Répartition',
    batchUpdate: 'Mise à Jour en Lot',
    importCsv: 'Importer CSV',
  }
};

const LANG_ORDER = ['en', 'es', 'fr'];
const LANG_LABELS = { en: 'English', es: 'Español', fr: 'Français' };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('typa_language');
    if (stored) return stored;
    // Auto-detect from browser language on first visit
    const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (browserLang.startsWith('es')) return 'es';
    if (browserLang.startsWith('fr')) return 'fr';
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('typa_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  const tx = (en, es, fr) => {
    if (language === 'fr') return fr || en;
    if (language === 'es') return es || en;
    return en;
  };

  const toggleLanguage = () => {
    const idx = LANG_ORDER.indexOf(language);
    const next = LANG_ORDER[(idx + 1) % LANG_ORDER.length];
    setLanguage(next);
  };

  const langLabel = LANG_LABELS[language] || 'English';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, tx, langLabel, LANG_LABELS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const getStatusLabel = (status, language) => {
  const statusMap = {
    intake_miami: { en: 'Intake Miami', es: 'Recibido Miami', fr: 'Réception Miami' },
    in_transit: { en: 'In Transit', es: 'En Tránsito', fr: 'En Transit' },
    arrived_san_jose: { en: 'Arrived San José', es: 'Llegó San José', fr: 'Arrivé San José' },
    ready_for_pickup: { en: 'Ready for Pickup', es: 'Listo para Recoger', fr: 'Prêt pour Retrait' },
    delivered: { en: 'Delivered', es: 'Entregado', fr: 'Livré' },
    pending: { en: 'Pending', es: 'Pendiente', fr: 'En Attente' },
    paid: { en: 'Paid', es: 'Pagado', fr: 'Payé' },
    overdue: { en: 'Overdue', es: 'Vencido', fr: 'En Retard' },
    cancelled: { en: 'Cancelled', es: 'Cancelado', fr: 'Annulé' },
  };
  return statusMap[status]?.[language] || status;
};
